import React from 'react';
import { APP_NAME, APP_NAME_LOWER } from '../config/branding';
import './HomePage.css';

const HomePage: React.FC = () => {
    return (
        <div className="home-page">
            {/* Hero Section */}
            <section className="hero">
                <div className="container">
                    <div className="hero-content">
                        <div className="hero-text">
                            <h1 className="hero-title">
                                <span className="gradient-text">{APP_NAME}</span>
                                {' '}ile Finansal Özgürlüğünüz
                            </h1>
                            <p className="hero-subtitle">
                                Gelir ve giderlerinizi takip edin, tasarruf hedeflerinizi belirleyin ve
                                finansal geleceğinizi güvence altına alın.
                            </p>
                            <div className="hero-buttons">
                                <a
                                    href="https://play.google.com/store/apps/details?id=com.saitgumus.budgetmanagement"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-primary hero-btn"
                                >
                                    📱 Hemen İndir
                                </a>
                                <a href="#features" className="btn btn-secondary hero-btn">
                                    Özellikleri Keşfet
                                </a>
                            </div>
                        </div>
                        <div className="hero-image">
                            <div className="app-mockup">
                                <div className="mockup-screen">
                                    <div className="mockup-header">
                                        <div className="mockup-status-bar">
                                            <span>9:41</span>
                                            <div className="mockup-icons">
                                                <span>📶</span>
                                                <span>📶</span>
                                                <span>🔋</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mockup-content">
                                        <div className="mockup-balance">
                                            <h3>Toplam Bakiye</h3>
                                            <div className="balance-amount">₺12,450</div>
                                        </div>
                                        <div className="mockup-chart">
                                            <div className="chart-bar" style={{ height: '60px' }}></div>
                                            <div className="chart-bar" style={{ height: '80px' }}></div>
                                            <div className="chart-bar" style={{ height: '40px' }}></div>
                                            <div className="chart-bar" style={{ height: '100px' }}></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Features Section */}
            <section id="features" className="section features-section">
                <div className="container">
                    <h2 className="section-title">Neden {APP_NAME}?</h2>
                    <p className="section-subtitle">
                        Modern teknoloji ile geliştirilmiş özellikler sayesinde finansal hedeflerinize
                        ulaşmanız artık çok daha kolay.
                    </p>

                    <div className="features-grid">
                        <div className="feature-card">
                            <div className="feature-icon">📊</div>
                            <h3>Detaylı Analiz</h3>
                            <p>Gelir ve giderlerinizi kategorilere ayırarak detaylı finansal analiz yapın.</p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon">🎯</div>
                            <h3>Hedef Belirleme</h3>
                            <p>Tasarruf hedeflerinizi belirleyin ve ilerlemenizi takip edin.</p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon">🔄</div>
                            <h3>Tekrarlayan İşlemler</h3>
                            <p>Düzenli ödemelerinizi otomatik olarak kaydedin ve unutmayın.</p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon">📱</div>
                            <h3>Mobil Uyumlu</h3>
                            <p>Her cihazda mükemmel çalışan responsive tasarım.</p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon">🔒</div>
                            <h3>Güvenli</h3>
                            <p>Verileriniz güvenli sunucularda şifrelenmiş olarak saklanır.</p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon">🌍</div>
                            <h3>Çok Dilli</h3>
                            <p>Türkçe ve İngilizce dil desteği ile herkes için erişilebilir.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* How It Works Section */}
            <section className="section how-it-works-section">
                <div className="container">
                    <h2 className="section-title">Nasıl Çalışır?</h2>
                    <p className="section-subtitle">
                        Sadece 3 basit adımda finansal kontrolünüzü ele alın.
                    </p>

                    <div className="steps-grid">
                        <div className="step-card">
                            <div className="step-number">1</div>
                            <h3>Hesap Oluşturun</h3>
                            <p>Uygulamayı indirin ve hızlıca hesap oluşturun.</p>
                        </div>

                        <div className="step-card">
                            <div className="step-number">2</div>
                            <h3>Varlıklarınızı Ekleyin</h3>
                            <p>Mevcut varlıklarınızı ve borçlarınızı sisteme girin.</p>
                        </div>

                        <div className="step-card">
                            <div className="step-number">3</div>
                            <h3>Takip Etmeye Başlayın</h3>
                            <p>Gelir ve giderlerinizi kaydedin, analizleri inceleyin.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Download Section */}
            <section className="section download-section">
                <div className="container">
                    <div className="download-content">
                        <h2 className="section-title">Hemen Başlayın</h2>
                        <p className="section-subtitle">
                            Finansal özgürlüğünüze giden yolda ilk adımı atın.
                            {APP_NAME_LOWER}&apos;i indirin ve hemen kullanmaya başlayın.
                        </p>

                        <div className="download-options">
                            <a
                                href="https://play.google.com/store/apps/details?id=com.saitgumus.budgetmanagement"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="download-option"
                            >
                                <div className="store-icon">📱</div>
                                <div className="store-info">
                                    <h3>Google Play Store</h3>
                                    <p>Android cihazlar için</p>
                                </div>
                                <div className="download-arrow">→</div>
                            </a>
                        </div>

                        <div className="app-info">
                            <div className="info-item">
                                <span className="info-label">Paket ID:</span>
                                <span className="info-value">com.saitgumus.budgetmanagement</span>
                            </div>
                            <div className="info-item">
                                <span className="info-label">Boyut:</span>
                                <span className="info-value">~15 MB</span>
                            </div>
                            <div className="info-item">
                                <span className="info-label">Gereksinimler:</span>
                                <span className="info-value">Android 6.0+</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default HomePage;
